import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
export function PrivacyPolicyPage() {
  const {
    t,
    setLocale,
    direction
  } = useLanguage();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-1042">
      <Header variant="dark" data-id="element-1043" />

      <main data-id="element-1044">
        <div className="h-[72px]" data-id="element-1045" />

        <section className="gradient-dark-horizontal py-4 md:py-5" data-id="element-1046">
          <div className="px-6 md:px-16 lg:px-24" data-id="element-1047">
            <h1 className="text-white font-semibold text-base md:text-lg uppercase tracking-wide" data-id="element-1048">
              {t('privacyPolicyPage.title')}
            </h1>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-white" aria-label="Privacy Policy Content" data-id="element-1049">
          <div className="container mx-auto px-6 md:px-12" data-id="element-1050">
            <div className="max-w-5xl space-y-8" data-id="element-1051">
              <div className="space-y-3" data-id="element-1052">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1053">
                  {t('privacyPolicyPage.general.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1054">
                  <p data-id="element-1055">{t('privacyPolicyPage.general.p1')}</p>
                  <p data-id="element-1056">{t('privacyPolicyPage.general.p2')}</p>
                  <p data-id="element-1057">{t('privacyPolicyPage.general.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1058">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1059">
                  {t('privacyPolicyPage.whyCollect.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1060">
                  <p data-id="element-1061">{t('privacyPolicyPage.whyCollect.p1')}</p>
                  <p data-id="element-1062">{t('privacyPolicyPage.whyCollect.p2')}</p>
                  <p data-id="element-1063">{t('privacyPolicyPage.whyCollect.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1064">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1065">
                  {t('privacyPolicyPage.consent.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1066">
                  <p data-id="element-1067">{t('privacyPolicyPage.consent.p1')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1068">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1069">
                  {t('privacyPolicyPage.changes.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1070">
                  <p data-id="element-1071">{t('privacyPolicyPage.changes.p1')}</p>
                  <p data-id="element-1072">{t('privacyPolicyPage.changes.p2')}</p>
                  <p data-id="element-1073">{t('privacyPolicyPage.changes.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1074">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1075">
                  {t('privacyPolicyPage.infoCollect.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1076">
                  <p data-id="element-1077">{t('privacyPolicyPage.infoCollect.p1')}</p>
                  <p data-id="element-1078">
                    <strong data-id="element-1079">{t('privacyPolicyPage.infoCollect.device')}</strong>{' '}
                    {t('privacyPolicyPage.infoCollect.p2')}
                  </p>
                  <p data-id="element-1080">{t('privacyPolicyPage.infoCollect.p3')}</p>
                  <p data-id="element-1081">
                    <strong data-id="element-1082">
                      {t('privacyPolicyPage.infoCollect.communications')}
                    </strong>{' '}
                    {t('privacyPolicyPage.infoCollect.p4')}
                  </p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1083">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1084">
                  {t('privacyPolicyPage.cookies.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1085">
                  <p data-id="element-1086">
                    <strong data-id="element-1087">
                      {t('privacyPolicyPage.cookies.whatAreCookies')}
                    </strong>
                  </p>
                  <p data-id="element-1088">{t('privacyPolicyPage.cookies.p1')}</p>
                  <p data-id="element-1089">
                    <strong data-id="element-1090">{t('privacyPolicyPage.cookies.categories')}</strong>
                  </p>
                  <p data-id="element-1091">
                    -{' '}
                    <strong data-id="element-1092">{t('privacyPolicyPage.cookies.firstParty')}</strong>{' '}
                    {t('privacyPolicyPage.cookies.firstPartyDesc')}
                  </p>
                  <p data-id="element-1093">
                    -{' '}
                    <strong data-id="element-1094">{t('privacyPolicyPage.cookies.thirdParty')}</strong>{' '}
                    {t('privacyPolicyPage.cookies.thirdPartyDesc')}
                  </p>
                  <p data-id="element-1095">
                    - <strong data-id="element-1096">{t('privacyPolicyPage.cookies.session')}</strong>{' '}
                    {t('privacyPolicyPage.cookies.sessionDesc')}
                  </p>
                  <p data-id="element-1097">
                    -{' '}
                    <strong data-id="element-1098">{t('privacyPolicyPage.cookies.persistent')}</strong>{' '}
                    {t('privacyPolicyPage.cookies.persistentDesc')}
                  </p>
                  <p data-id="element-1099">
                    <strong data-id="element-1100">{t('privacyPolicyPage.cookies.weUse')}</strong>
                  </p>
                  <p data-id="element-1101">{t('privacyPolicyPage.cookies.p2')}</p>
                  <p data-id="element-1102">{t('privacyPolicyPage.cookies.p3')}</p>
                  <p data-id="element-1103">{t('privacyPolicyPage.cookies.p4')}</p>
                  <p data-id="element-1104">{t('privacyPolicyPage.cookies.p5')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1105">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1106">
                  {t('privacyPolicyPage.howWeUse.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1107">
                  <p data-id="element-1108">{t('privacyPolicyPage.howWeUse.p1')}</p>
                  <p data-id="element-1109">{t('privacyPolicyPage.howWeUse.p2')}</p>
                  <p data-id="element-1110">a) {t('privacyPolicyPage.howWeUse.a')}</p>
                  <p data-id="element-1111">b) {t('privacyPolicyPage.howWeUse.b')}</p>
                  <p data-id="element-1112">c) {t('privacyPolicyPage.howWeUse.c')}</p>
                  <p data-id="element-1113">d) {t('privacyPolicyPage.howWeUse.d')}</p>
                  <p data-id="element-1114">{t('privacyPolicyPage.howWeUse.p3')}</p>
                  <p data-id="element-1115">a) {t('privacyPolicyPage.howWeUse.useA')}</p>
                  <p data-id="element-1116">b) {t('privacyPolicyPage.howWeUse.useB')}</p>
                  <p data-id="element-1117">c) {t('privacyPolicyPage.howWeUse.useC')}</p>
                  <p data-id="element-1118">d) {t('privacyPolicyPage.howWeUse.useD')}</p>
                  <p data-id="element-1119">e) {t('privacyPolicyPage.howWeUse.useE')}</p>
                  <p data-id="element-1120">f) {t('privacyPolicyPage.howWeUse.useF')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1121">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1122">
                  {t('privacyPolicyPage.communication.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1123">
                  <p data-id="element-1124">{t('privacyPolicyPage.communication.p1')}</p>
                  <p data-id="element-1125">• {t('privacyPolicyPage.communication.item1')}</p>
                  <p data-id="element-1126">• {t('privacyPolicyPage.communication.item2')}</p>
                  <p data-id="element-1127">• {t('privacyPolicyPage.communication.item3')}</p>
                  <p data-id="element-1128">• {t('privacyPolicyPage.communication.item4')}</p>
                  <p data-id="element-1129">{t('privacyPolicyPage.communication.p2')}</p>
                  <p data-id="element-1130">{t('privacyPolicyPage.communication.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1131">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1132">
                  {t('privacyPolicyPage.disclosure.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1133">
                  <p data-id="element-1134">{t('privacyPolicyPage.disclosure.p1')}</p>
                  <p data-id="element-1135">{t('privacyPolicyPage.disclosure.p2')}</p>
                  <p data-id="element-1136">
                    <strong data-id="element-1137">
                      {t('privacyPolicyPage.disclosure.thirdParties')}
                    </strong>
                  </p>
                  <p data-id="element-1138">{t('privacyPolicyPage.disclosure.p3')}</p>
                  <p data-id="element-1139">{t('privacyPolicyPage.disclosure.p4')}</p>
                  <p data-id="element-1140">{t('privacyPolicyPage.disclosure.p5')}</p>
                  <p data-id="element-1141">{t('privacyPolicyPage.disclosure.p6')}</p>
                  <p data-id="element-1142">a) {t('privacyPolicyPage.disclosure.shareA')}</p>
                  <p data-id="element-1143">b) {t('privacyPolicyPage.disclosure.shareB')}</p>
                  <p data-id="element-1144">
                    <strong data-id="element-1145">
                      {t('privacyPolicyPage.disclosure.thirdPartySites')}
                    </strong>
                  </p>
                  <p data-id="element-1146">{t('privacyPolicyPage.disclosure.p7')}</p>
                  <p data-id="element-1147">
                    <strong data-id="element-1148">
                      {t('privacyPolicyPage.disclosure.legalAuthorities')}
                    </strong>
                  </p>
                  <p data-id="element-1149">{t('privacyPolicyPage.disclosure.p8')}</p>
                  <p data-id="element-1150">a) {t('privacyPolicyPage.disclosure.legalA')}</p>
                  <p data-id="element-1151">b) {t('privacyPolicyPage.disclosure.legalB')}</p>
                  <p data-id="element-1152">c) {t('privacyPolicyPage.disclosure.legalC')}</p>
                  <p data-id="element-1153">{t('privacyPolicyPage.disclosure.p9')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1154">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1155">
                  {t('privacyPolicyPage.storage.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1156">
                  <p data-id="element-1157">{t('privacyPolicyPage.storage.p1')}</p>
                  <p data-id="element-1158">{t('privacyPolicyPage.storage.p2')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1159">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1160">
                  {t('privacyPolicyPage.retention.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1161">
                  <p data-id="element-1162">{t('privacyPolicyPage.retention.p1')}</p>
                  <p data-id="element-1163">a) {t('privacyPolicyPage.retention.a')}</p>
                  <p data-id="element-1164">b) {t('privacyPolicyPage.retention.b')}</p>
                  <p data-id="element-1165">c) {t('privacyPolicyPage.retention.c')}</p>
                  <p data-id="element-1166">{t('privacyPolicyPage.retention.p2')}</p>
                  <p data-id="element-1167">{t('privacyPolicyPage.retention.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1168">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1169">
                  {t('privacyPolicyPage.security.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1170">
                  <p data-id="element-1171">{t('privacyPolicyPage.security.p1')}</p>
                  <p data-id="element-1172">• {t('privacyPolicyPage.security.item1')}</p>
                  <p data-id="element-1173">• {t('privacyPolicyPage.security.item2')}</p>
                  <p data-id="element-1174">• {t('privacyPolicyPage.security.item3')}</p>
                  <p data-id="element-1175">• {t('privacyPolicyPage.security.item4')}</p>
                  <p data-id="element-1176">• {t('privacyPolicyPage.security.item5')}</p>
                  <p data-id="element-1177">• {t('privacyPolicyPage.security.item6')}</p>
                  <p data-id="element-1178">{t('privacyPolicyPage.security.p2')}</p>
                  <p data-id="element-1179">{t('privacyPolicyPage.security.p3')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1180">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1181">
                  {t('privacyPolicyPage.gdpr.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1182">
                  <p data-id="element-1183">{t('privacyPolicyPage.gdpr.p1')}</p>
                  <p data-id="element-1184">• {t('privacyPolicyPage.gdpr.right1')}</p>
                  <p data-id="element-1185">• {t('privacyPolicyPage.gdpr.right2')}</p>
                  <p data-id="element-1186">• {t('privacyPolicyPage.gdpr.right3')}</p>
                  <p data-id="element-1187">• {t('privacyPolicyPage.gdpr.right4')}</p>
                  <p data-id="element-1188">• {t('privacyPolicyPage.gdpr.right5')}</p>
                  <p data-id="element-1189">{t('privacyPolicyPage.gdpr.p2')}</p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1190">
                <h2 className="text-[#061D76] text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-1191">
                  {t('privacyPolicyPage.complain.heading')}
                </h2>
                <div className="text-[#061D76] text-[13px] md:text-sm leading-[1.7] space-y-3" data-id="element-1192">
                  <p data-id="element-1193">{t('privacyPolicyPage.complain.p1')}</p>
                  <p data-id="element-1194">{t('privacyPolicyPage.complain.p2')}</p>
                  <p data-id="element-1195">
                    <strong data-id="element-1196">
                      {t('privacyPolicyPage.complain.supervisory')}
                    </strong>
                  </p>
                  <p data-id="element-1197">{t('privacyPolicyPage.complain.p3')}</p>
                  <div className="mt-2" data-id="element-1198">
                    <p className="font-semibold" data-id="element-1199">
                      {t('privacyPolicyPage.complain.office')}
                    </p>
                    <p data-id="element-1200">{t('privacyPolicyPage.complain.address1')}</p>
                    <p data-id="element-1201">{t('privacyPolicyPage.complain.address2')}</p>
                    <p data-id="element-1202">{t('privacyPolicyPage.complain.tel')}</p>
                    <p data-id="element-1203">{t('privacyPolicyPage.complain.fax')}</p>
                    <p data-id="element-1204">{t('privacyPolicyPage.complain.email')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1205" />
    </div>;
}